<template>
  <div class="home">
    <header class="home-header">
      <div class="contation">
        <!-- logo -->
        <div class="logo">
          <img src="../../assets/logo.png" alt="" />
        </div>



        <ul class="nav">
          <li class="active">
            <a style="color: #fff" href="#/home">首页</a>
          </li>
          <li>
            <a href="#/counseling">咨询服务</a>
          </li>
          <li><a href="#/AboutUs">关于我们</a></li>
        </ul>
        <div class="moblie">
          <a href="">客服热线: 010-82754334</a>
        </div>
        <div class="consult">
          <p class="play-Ctext">国体智慧云动</p>
          <p class="mbig">大数据分析+社群电商+数字体育赛事</p>
          <p class="play-text">专注于体育行业服务，提供一站式解决方案</p>
        </div>
      </div>
    </header>
    <div class="main">
      <div class="App">
        <div class="left-text">
          <div class="app-text">
            <h1>国体大数据 App</h1>
            <p>
              国体大数据APP是全民健身数据服务手机软件啊，致力于为各地体育局以及相应的运营人员，体育相关人员提供全民健身大数据中心完整解决方案的平台
            </p>
          </div>

          <div class="img">
            <img src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_09.gif" alt="" />
          </div>
          <div class="img">
            <img src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_12.gif" alt="" />
          </div>
        </div>
        <div class="left-pic">
          <img src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_07.gif" alt="" />
        </div>
      </div>
      <div class="commerce">
        <div class="contion">
          <div class="commerce-text">
            <h1>社 群 电 商</h1>
            <p>
              精品优选是京东集团的京东社群用户运营渠道，为我司打造的一个拥有京东商城1000w+
              商品池用户选择的一个社群服务体系凭条；
              用户可以在平台进行推广及享受收益，除享受商品现有佣金外，还可以拿到精品优选额外分享赚，每单分成比例高达佣金的10%
            </p>
          </div>
          <div class="commerce-pic">
            <img src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_15.gif" alt="" />
          </div>
        </div>
      </div>
      <div class="oline">
        <div class="img">
          <img src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_18.gif" alt="" />
        </div>
        <div class="text">
          <h1>线 上 赛 事</h1>
          <p>
            在疫情防控常态化的形势下，今年运动会积极探索线上线下融合度办赛方式，在展开线下赛事的基础上，推出了丰富的线上赛事，实现体育赛事活动线上线下全覆盖
          </p>
          <p>
            技术能力：
            可实现视频云赛事、云端健步走（计划）、AI赛事（通过al技术实现人体行为识别）、智能物联赛事（智能健身器材设备物联网比赛）
            等参赛形式
          </p>
        </div>
      </div>
      <div class="partner_main">
        <div class="partner">
          <h3>部分合作伙伴</h3>
          <img src="../../assets/ds.png" alt="">
          <!-- <ul class="partner-box">
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_21.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_23.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_25.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_27.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_33.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_34.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_35.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_41.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_41.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_43.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_44.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_50.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_49.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_27.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_51.gif"
                alt=""
              />
            </li>
            <li>
              <img
                src="../../assets/1b4911e0033cc19bce07f2e6bd7c135_41.gif"
                alt=""
              />
            </li>
          </ul> -->
        </div>
      </div>
      <Floot></Floot>
    </div>
  </div>
</template>

<script>
import Floot from '../../components/floot'
export default {
  components: {
    Floot,
  },
}
</script>

<style>
.home {
  width: 100%;
}

.home-header {
  height: 700px;
  width: 100%;
  background-image: url('../../assets/bj1.png');
  background-size: cover;
}

.mbig {
  color: #fff;
}

.play-Ctext {
  color: #fff;
  font-size: 60px;
}

.play-text {
  font-size: 12px;
  color: #fff;
  opacity: 0.3;
}

.main {
  height: 2440px;
  width: 100%;
  margin: 0 auto;
}

.main .App {
  height: 540px;
  width: 1200px;
  margin: 0 auto;
  display: flex;

  justify-content: space-around;
  align-items: center;
}

.main .App .app-text h1 {
  font-weight: normal;
}

.main .App .app-text p {
  width: 700px;
  font-size: 14px;
  color: #999;
}

.main .App .left-text .img {
  margin-top: 40px;
  width: 200px;
  height: 30px;
}

.main .commerce {
  height: 460px;

  background: #eff2f4;
}

.main .commerce .contion {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main .commerce .contion .commerce-text {
  width: 700px;
  text-align: center;
}

.main .commerce .contion .commerce-text p {
  color: #777;
  font-size: 12px;
}

.main .oline {
  height: 500px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.main .oline .text {
  width: 550px;
  text-align: center;
  float: right;
}

.main .oline .text p {
  color: #777;
  font-size: 12px;
}

.main .partner_main {
  height: 830px;
  position: relative;
  background-image: url("../../assets/bj22.png");
}

.main .partner {
  height: 830px;
  width: 1200px;
  position: relative;
  top: 5%;
  margin: 0 auto;
}

.consult {
  position: absolute;
  top: 232px;
}

.main .partner h3 {
  font-size: 40px;
  font-weight: normal;
}

.main .partner .partner-box {
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}

.main .partner .partner-box li {
  width: 24%;
  margin-left: 5px;
  margin-top: 10px;
}
</style>
